import { createRoot } from 'react-dom/client';
import React from 'react';
import ToastContainer from './ToastContainer';
import { ToastMessage, ToastType } from './types';

// 用于存储 ToastContainer 的 React Root
// let toastRoot: any = null; 
// 用于存储 ToastContainer 实例的引用，以便调用其方法
const toastContainerRef: { current: { addToast: (toast: ToastMessage) => void } | null } = { current: null };

// 确保 ToastContainer 只被挂载一次
const ensureToastContainer = () => {
    if (!document.getElementById('toast-container-root')) {
        const containerDiv = document.createElement('div');
        containerDiv.id = 'toast-container-root';
        document.body.appendChild(containerDiv);
        
        // 使用新的 React 18 createRoot API
        const root = createRoot(containerDiv);
        
        // 渲染 ToastContainer 并获取其引用
        root.render(
            <React.StrictMode>
                <ToastContainer ref={toastContainerRef} />
            </React.StrictMode>
        );
    }
};

let toastCount = 0;

export const toast = {
    show: (message: string, type: ToastType = 'info', duration: number = 3000) => {
        ensureToastContainer();
        const id = `toast-${toastCount++}`;
        if (toastContainerRef.current) {
            toastContainerRef.current.addToast({ id, message, type, duration });
        } else {
            // 应急处理或延迟调用，理论上 ensureToastContainer 后 ref 应该可用
            console.warn('ToastContainer ref not available yet.');
            setTimeout(() => {
                 if (toastContainerRef.current) {
                    toastContainerRef.current.addToast({ id, message, type, duration });
                }
            }, 100); // 短暂延迟后重试
        }
    },
    success: (message: string, duration?: number) => toast.show(message, 'success', duration),
    error: (message: string, duration?: number) => toast.show(message, 'error', duration),
    warning: (message: string, duration?: number) => toast.show(message, 'warning', duration),
    info: (message: string, duration?: number) => toast.show(message, 'info', duration),
};

// 也导出 ToastContainer，如果用户想在特定地方自定义渲染（虽然目标是全局自动）
export { default as ToastContainer } from './ToastContainer';
export type { ToastMessage, ToastType } from './types';
export { toastContainerRef };
